<template>
    <v-list-item>
        <v-list-item-action>
            <v-tooltip bottom :disabled="canSign || readonly">
                <template v-slot:activator="{ on }">
                    <span v-on="on"><v-checkbox :disabled="!canSign || readonly" v-model="signed" @click="handleCheckboxClicked"></v-checkbox></span>
                </template>
                <span>Signature will be available after report creation</span>
            </v-tooltip>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title>{{item.name}} </v-list-item-title>
            <v-list-item-subtitle><span v-bind:class="signStatusClasses" v-if="canSign">{{signStatus}}</span></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <v-btn icon text @click="handleDeleteButtonClick" :disabled="deleteButtonDisabled" :loading="progress(['deleteSpecialistFromReport', item.id])">
                <v-icon>fas fa-trash</v-icon>
            </v-btn>
        </v-list-item-action>
        <v-dialog v-if="signDialogVisible" v-model="signDialogVisible" @keydown.esc="handleCancelSign" max-width="600">
            <v-card>
                <v-card-title class="headline">Signature confirmation</v-card-title>
                <v-card-text class="text--primary">
                    Please, enter pin-code for: <b>{{item.name}}</b>
                    <v-text-field label="Pin-code"
                                  text
                                  ref="pinCodeInput"
                                  v-model="signConfirmationPinCode"
                                  :rules="pinCodeRules"
                                  :error-messages="signConfirmationErrorMessage"
                                  @keydown.enter.native="handleEnterKeyPressed"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1"
                           text
                           @click="handleSignOkButtonClick">
                        Ok
                    </v-btn>

                    <v-btn color="gray darken-1"
                           text
                           @click="handleSignCancelButtonClick">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-list-item>
</template>

<script>

    import {mapGetters, mapActions} from 'vuex'
    import _ from 'lodash'

    export default {
        name: 'SpecialistItem',
        props: {
            item: Object,
            canSign: Boolean,
            readonly: Boolean
        },
        data() {
            return {
                signDialogVisible: false,
                signConfirmationPinCode: null,
                signConfirmationErrorMessage: null,
                pinCodeRules: [
                    v => !!v || 'Enter pin-code'
                ]
            }
        },
        computed: {
            ...mapGetters('pgtCases', {
                progress: 'progress'
            }),
            deleteButtonDisabled() {
                return this.readonly || this.progress(['deleteSpecialistFromReport', this.item.id])
            },
            signed: {
                get () {
                    return this.item.signed
                },
                set (value) {
                    //this.item.signed = false

                    console.log(value)
                }
            },
            signStatus () {
                return this.item.signed ? 'Signed' : 'Sign required'
            },
            signStatusClasses () {
                return {
                    'signed': this.item.signed,
                    'sign-required': !this.item.signed
                }
            }
        },
        methods: {
            ...mapActions('report', {
                signReport: 'signReport'
            }),
            handleCheckboxClicked: _.debounce(function() {
                if (!this.item.signed) {
                    this.$emit('onBeforeSign', this.showSignDialog)
                    return
                }

                this.$emit('onDeleteSign', this.item.id)
            }, 150),
            showSignDialog () {
                this.signDialogVisible = true
                this.$nextTick(() => {
                    this.$refs['pinCodeInput'].focus()
                })
            },
            hideSignDialog () {
                this.signDialogVisible = false
            },
            resetSignDialog () {
                this.hideSignDialog()
                this.signConfirmationPinCode = null
                this.signConfirmationErrorMessage = null
            },
            handleCancelSign () {
                this.hideSignDialog()
            },
            handleSignCancelButtonClick() {
                this.hideSignDialog()
            },
            async handleSignOkButtonClick () {
                this.validatePinCode()
            },
            async handleEnterKeyPressed () {
                this.validatePinCode()
            },
            validatePinCode () {
                if (!this.item.pinCode || this.item.length === 0) {
                    this.signConfirmationErrorMessage = 'Please, enter pin-code'
                    return
                }

                if (this.item.pinCode !== this.signConfirmationPinCode) {
                    this.signConfirmationErrorMessage = 'Wrong pin-code'
                    return
                }

                this.$emit('onSign', this.item.id)

                this.resetSignDialog()
            },
            handleDeleteButtonClick () {
                this.$emit('delete', this.item.id)
            }
        }
    }
</script>

<style scoped>
    .signed {
        color: #4caf50;
    }

    .sign-required {
        color: #ff5252;
    }
</style>